const typeToIDs = {
  blog: [4, 'HealthUnlocked.Aurora.DataModel.Content.Blog'],
  answer: [2, 'HealthUnlocked.Aurora.DataModel.Content.Answer'],
  reply: [19, 'HealthUnlocked.Aurora.DataModel.Content.Comment'],
  poll: [6, 'HealthUnlocked.Aurora.DataModel.Content.Poll'],
  question: [1, 'HealthUnlocked.Aurora.DataModel.Content.Question'],
  pollChoice: [7],
};

const idToProcess = {};
Object.entries(typeToIDs).forEach(
  ([key, values]) => values.forEach(
    value => idToProcess[value] = key
  )
);

function processAccordingPostType(post = {}, processes = {}) {
  return processes[idToProcess[post.postTypeId]];
}

const typeToProcess = {
  'post-rate': (notification, processes) =>
    processAccordingPostType({ postTypeId: notification.post.postTypeId }, {
      blog: processes.like,
      reply: processes.likeReply,
    }),
  'user-follows': 'followUser',
  'post-follows': 'followPost',
  'user-mention': (notification, processes) =>
    processAccordingPostType({ postTypeId: notification.post.postTypeId }, {
      blog: processes.mention,
      reply: processes.mentionReply,
    }),
  'items': (notification, processes) =>
    processAccordingPostType({ postTypeId: notification.post.postTypeId }, processes),
  'custom-notification': 'customNotification',
};

export function processAccordingNotificationType(notification = {}, processes = {}) {
  const processKey = typeToProcess[notification.type];
  return typeof processKey === 'function' ?
    processKey(notification, processes) :
    processes[processKey];
}



// WEBPACK FOOTER //
// ./app/assets/js/utils/processAccordingNotificationType.js